module.exports = __webpack_public_path__ + "img/fun.587709d6.svg";